export default __webpack_public_path__ + "static/media/KOD0019-min.dbd5cc19.webp";